import { ChatItem, ChatItemLoading } from "./ChatItem";

export default function TicketsList({
  searchChatItems,
  activeChat,
  setActiveChat,
  loading,
  chatItems,
  setChatItems,
}) {
  return (
    <div
      className="mt-7 scroll scroll-pull ps ps--active-y overflow-auto"
      style={{
        height: "443px",
        textAlign: loading ? "center" : "",
      }}
    >
      {loading
        ? Array.from(Array(6).keys()).map((index) => (
            <ChatItemLoading key={index} />
          ))
        : chatItems
            .filter((filterdItems) =>
              filterdItems.title
                .toLowerCase()
                .includes(searchChatItems.toLowerCase())
            )
            .map((item, index) => (
              <ChatItem
                onClick={() => {
                  setActiveChat({
                    ...activeChat,
                    ticket_id: item.ticket_id,
                  });
                  setChatItems(
                    chatItems.map((chatItem) => {
                      if (chatItem.ticket_id === item.ticket_id) {
                        return {
                          ...chatItem,
                          unread_ticket: false,
                        };
                      }
                      return chatItem;
                    })
                  );
                }}
                key={index}
                data={item}
                activeChat={activeChat}
              />
            ))}
    </div>
  );
}
